<template>
  <div class="hello">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
    <img src="@/assets/logo.png" width="32" height="32"/>
    <h1>{{ msg }} <span style="font-size: 9px;">v{{ version }}</span></h1>
    <hr>
    <div style="border-style:solid">
      1. 個人薪資結構異動表
      <file-pond
          name="file"
          ref="pond1"
          label-idle="點擊選擇或拖曳Excel檔案到這裡..."
          maxFileSize="5MB"
          v-bind:allow-multiple="false"
          accepted-file-types="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          v-on:init="handleFilePondInit"
          v-on:removefile="handleFileRemove"
          v-bind:server="serverA"
        />
    </div>
    <div style="border-style:solid">
      2. 年資檔:
      <file-pond
          name="file"
          ref="pond2"
          label-idle="點擊選擇或拖曳Excel檔案到這裡..."
          maxFileSize="5MB"
          v-bind:allow-multiple="false"
          accepted-file-types="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          v-on:init="handleFilePondInit"
          v-on:removefile="handleFileRemove"
          v-bind:server="serverB"
        />
    </div>
    <br/>
    <button @click="download()" class="btn">下載</button>
    <br/><br/>
    <!--
    <div>
      <label for="email">Email:</label>
      <input type="email" v-model="email" id="email" />
    </div>
    <div>
      <label for="verificationCode">驗證碼:</label>
      <input type="text" v-model="verificationCode" id="verificationCode" />
    </div>
    <br/>
    <button @click="register()" class="btn">註冊</button>
  -->
  </div>
</template>

<script>
import  vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FileSaver from 'file-saver';
import axios from 'axios';

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType
);

const SERVER_API = 'https://app.fishgold.net/'
const UPLOAD_SERVER = SERVER_API + "upload"
// const UPLOAD_PATH = SERVER_API + "uploads/"

export default {
  name: 'HelloWorld',
  components: {
    FilePond,
  },
  props: {
    msg: String
  },
  data() {
    return {
      version: "",
      serverA: {
        url: UPLOAD_SERVER,
        process: {
          ondata: (formData) => {
            formData.append('type', '個人薪資結構異動表');
            return formData;
          },
        },
      },
      serverB: {
        url: UPLOAD_SERVER,
        process: {
          ondata: (formData) => {
            formData.append('type', '年資檔');
            return formData;
          },
        },
      },
    }
  },
  mounted () {
    this.version = process.env.PACKAGE_VERSION || '0';
    console.log(process.env.PACKAGE_VERSION || '0');
  },
  methods: {
    handleFilePondInit: function () {
        console.log("FilePond has initialized");
        // FilePond instance methods are available on `this.$refs.pond`
      },
    handleFileRemove() {
      console.log("remove file fired!")
    },
    download() {
      axios({
        url: SERVER_API + 'download',
        method: 'GET',
        responseType: 'blob',})
        .then(res => {

          this.$refs.pond1.removeFile()
          this.$refs.pond2.removeFile()    
          const blob = new Blob([res.data], { type: 'application/octet-stream' })
          FileSaver.saveAs(blob, "最後總表.xlsx");
        })
        .catch(error => {
          alert('請先上傳正確檔案!');
          console.error("There was an error!", error);
        });
    },
    register() {
      if (this.verificationCode !== '7777') {
        alert('驗證碼錯誤!');
        return;
      }

      const now = new Date('2024-08-23T15:36:00');
      const formattedDate = `${now.getFullYear()}/${now.getMonth() + 1}/${now.getDate()}`;
      const formattedStartTime = `${now.getHours()}:${now.getMinutes()}`;
      const formattedEndTime = `${now.getHours() + 1}:${now.getMinutes()}`;


      const data = {
        gmail: this.email,
        meetings: [
          {
            date: formattedDate,
            start_time: formattedStartTime,
            end_time: formattedEndTime,
            subject: "Project Kickoff Meeting",
            location: "Conference Room A",
            room_name: "Conference Room A",
            organizer_name: "Will Lien",
            extension_number: "1234",
            department_code: "D001",
            department_name: "Engineering"
          }
        ]
      };

      axios.post(SERVER_API + 'add_meetings', data, { 
        maxRedirects: 0,
        validateStatus: function (status) {
          return status >= 200 && status < 400;
        }
      })
        .then(response => {
          if (response.data && response.data.auth_url) {
            window.location.href = response.data.auth_url;
          } else {
            alert('註冊成功!');
          }
        })
        .catch(error => {
          console.error("There was an error!", error);
          if (error.response && error.response.data && error.response.data.auth_url) {
            window.location.href = error.response.data.auth_url;
          } else {
            alert('註冊失敗!');
          }
        });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
/* Style buttons */
.btn {
  background-color: DodgerBlue;
  border: none;
  color: white;
  padding: 12px 30px;
  cursor: pointer;
  font-size: 20px;
}

/* Darker background on mouse-over */
.btn:hover {
  background-color: RoyalBlue;
}


</style>
